module.exports = __webpack_public_path__ + "img/wechat01.dba4119f.png";